export const defaultWidgetHours = {
  overtime_hours: 0,
  regular_hours: 0,
  approved_hours: 0,
  pending_hours: 0,
};
